import { styled } from "@mui/material/styles";

export const DiaryContainer = styled("div", {
  name: "DiaryContainer",
})(() => ({
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  position: "relative",
  height: "100%",
}));
